import { AddObjectEvent, useDispatchAddObjectEvent } from "./useAddObjectEvent";

export function useAddImageObject() {
  const dispatchAddObjectEvent = useDispatchAddObjectEvent();

  return (data: Extract<AddObjectEvent["payload"], { type: "image" }>["data"]) => {
    dispatchAddObjectEvent({
      type: "image",
      data,
    });
  };
}
